import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { useState } from 'react';

const ResetSubscription = ({ open, onClose, handleResetSubscription }) => {
  const [resetOptions, setResetOptions] = useState({
    reset_predictive_occupancy_detection: true,
    reset_preheat: false,
    reset_cooldown: false,
  });

  const handleToggle = (key) => (event) => {
    setResetOptions((prev) => ({
      ...prev,
      [key]: event.target.checked,
    }));
  };

  const handleConfirm = () => {
    handleResetSubscription(resetOptions);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 2 }}>
          Select which parts of the machine learning model you want to reset for
          this subscription. This action cannot be undone.
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={resetOptions.reset_predictive_occupancy_detection}
                onChange={handleToggle('reset_predictive_occupancy_detection')}
              />
            }
            label="Reset predictive occupancy detection"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={resetOptions.reset_preheat}
                onChange={handleToggle('reset_preheat')}
              />
            }
            label="Reset preheat model"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={resetOptions.reset_cooldown}
                onChange={handleToggle('reset_cooldown')}
              />
            }
            label="Reset cooldown model"
          />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          startIcon={<RestoreRoundedIcon />}
          variant="contained"
          color="warning"
        >
          Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetSubscription;
